// @ts-nocheck


import React from 'react';
import styled from 'styled-components';
import Input from 'antd/lib/input';

import {
  Filter,
  FilterButtonsContainer,
  FilterContainer,
  FilterItem } from
'./../../../components';

import Field from './../../../components/card/Field';

const SpoilerContent = styled.div.withConfig({ displayName: "Filter__SpoilerContent", componentId: "sc-s0vr5j-0" })(["padding:16px;"]);













export const StockPartFilter = ({
  filter,
  cleanFilter,
  applyFilter
}) =>
<SpoilerContent>
    <FilterContainer>
      <Filter
      cleanFilter={cleanFilter}
      applyFilter={applyFilter}
      initialValues={filter}>

        {({
        values,
        changeValue,
        applyFilter,
        cleanFilter
      }) =>
      <>
            <FilterItem>
              <Field mBottomNone>
                <Input
              placeholder="Наименование"
              size="small"
              onChange={(e) =>
              changeValue('name', e.target.value || undefined)
              }
              value={values['name']} />

              </Field>
            </FilterItem>

            <FilterButtonsContainer
          applyFilter={applyFilter}
          cleanFilter={cleanFilter} />

          </>
      }
      </Filter>
    </FilterContainer>
  </SpoilerContent>;


export default StockPartFilter;
